if (!customElements.get('hero-video')) {
  class HeroVideo extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.soundBtn = document.querySelector('.js-hero-video-sound');
    }

    connectedCallback() {
      this.soundBtn?.addEventListener('click', this.handleSoundBtn);
    }

    handleSoundBtnClick = (event) => {
      event.preventDefault();
      if (this.video.muted) {
        this.video.muted = false;
        this.soundBtn.classList.remove('is-muted');
      } else {
        this.video.muted = true;
        this.soundBtn.classList.add('is-muted');
      }
    }
  }
  customElements.define('hero-video', HeroVideo);
}
